export default __webpack_public_path__ + "48a9f24b3cc2ce839776f1932560421b.wav";